export default {
	'onboarding.addLogo': 'Add Logo',
	'onboarding.addManySkills': 'Great! You can add as many as <span class="skill-count">%{skillsLeft}</span> more %{skillsLeft} skill |||| %{skillsLeft} skills; the more the better',
	'onboarding.addPhoto': 'Add Photo',
	'onboarding.additionalSkills': 'Add additional skills to your profile to become eligible for more assignments',
	'onboarding.assignmentsNearYou': 'assignments available near you',
	'onboarding.atLeastOne': 'At least one industry must be chosen.',
	'onboarding.bankingInformation': 'Complete your banking information so you can withdraw your funds',
	'onboarding.companyOverviewLength': 'Company Overview must be 1000 characters or less.',
	'onboarding.completeTaxInformation': 'Complete your tax information so you can get get paid for assignments',
	'onboarding.defaultFormats': 'Default formats (distance, time, currency, etc.) are set according to the country entered in the address field below. This can be changed at anytime in \'Settings\'.',
	'onboarding.done': 'Done!',
	'onboarding.dropPin': 'Please use the drop pin on the map to locate a valid street address.',
	'onboarding.expertise': 'Expertise',
	'onboarding.firstNameLength': 'First Name must be 50 characters or less.',
	'onboarding.getDiscoveredByCompanies': 'Get discovered by companies and find the most relevant work by adding at least',
	'onboarding.industry': 'Industry',
	'onboarding.industryCheckedBoolean': 'Industry checked needs to be a boolean.',
	'onboarding.industryIdNotNegative': 'Industry id cannot be negative.',
	'onboarding.industryIdNumber': 'Industry id needs to be a number.',
	'onboarding.industryKeyRequired': 'Industry %{key} is a required field.',
	'onboarding.industryName': 'Industry name needs to be a string.',
	'onboarding.jobTitle': 'Job Title',
	'onboarding.lastNameLength': 'Last Name must be 50 characters or less.',
	'onboarding.location': 'Location',
	'onboarding.optional': '%{defaultOption} (optional)',
	'onboarding.profileInformation': 'Profile Information',
	'onboarding.searchAndApplyForAssignments': 'Great! You are now ready to search and apply for assignments.',
	'onboarding.selectIndustry': 'Select an Industry',
	'onboarding.thereAre': 'There are',
	'onboarding.tips': 'A few tips before you get started:',
	'onboarding.updateSkillsLater': 'Nice! You can always update your skills in the \'My Profile\' section later.',
	'onboarding.validEmailAddress': 'Please enter a valid email address',
	'onboarding.validName': 'Cannot find a valid %{name}.',
	'onboarding.validPhoneNumber': 'Please enter a valid phone number.',
	'onboarding.validResponses': 'Please provide valid responses for all required fields.',
	'onboarding.validURI': 'Website is not a valid URI.',
	'onboarding.workExperience': 'Years of Work Experience'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/onboarding.js